(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-btn-addtocart]');
    if (!btn || btn.disabled) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var form = btn.closest('form');
    if (!form) return;

    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;

    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

    btn.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(idInput.value, 10), quantity: qty })
    })
    .then(function (res) {
      if (!res.ok) return res.json().then(function (d) { throw d; });
      window.location.reload();
    })
    .catch(function (err) {
      btn.classList.remove('is-loading');
      var msg = (err && err.description) || (err && err.message) || '';
      if (msg && typeof showWarning === 'function') showWarning(msg);
    });
  }, true);

})();
